let firstPart = document.getElementsByClassName("seller-content")[0];
let secondPart = document.getElementsByClassName("buyer-content")[0];

const primaryButton = document.getElementsByClassName("pb")[0];
const secondaryButton = document.getElementsByClassName("sb")[0];

// console.log("PB", primaryButton);
// console.log("SB", secondaryButton);

primaryButton.style.borderBottom = "3px solid #3A9282";
secondaryButton.style.borderBottom = "1px solid #000000";
firstPart.style.display= "none";
secondPart.style.display= "flex";

// // Event listener for primaryButton
primaryButton.addEventListener("click", function() {
    firstPart.style.display = "none";   // Show firstPart
    secondPart.style.display = "flex";   // Hide secondPart
	primaryButton.style.borderBottom = "3px solid #3A9282";
	secondaryButton.style.borderBottom = "1px solid #000000";
});

// // Event listener for secondaryButton
secondaryButton.addEventListener("click", function() {
    firstPart.style.display = "flex";    // Hide firstPart
    secondPart.style.display = "none";  // Show secondPart
	
	primaryButton.style.borderBottom = "1px solid #000000";
	secondaryButton.style.borderBottom = "3px solid #3A9282";
});